import { render, staticRenderFns } from "./SiLoginRecords.vue?vue&type=template&id=0e975d66&"
import script from "./SiLoginRecords.vue?vue&type=script&lang=js&"
export * from "./SiLoginRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports